class AccessibilityHelper {
    constructor() {

        // wait a moment for recaptcha
        // to load
        setTimeout(() => {
            this.initRecatpcha();
        }, 1000);
    }
    // Fix lack of label on recaptcha responses.
    initRecatpcha() {
        let textareas = document.querySelectorAll(".g-recaptcha-response");

        for (let i = 0; i < textareas.length; i++) {
            let element = textareas[i];

            element.setAttribute("aria-hidden", "true");
            element.setAttribute("aria-label", "do not use");
            element.setAttribute("aria-readonly", "true");
        }
    }
}

export default AccessibilityHelper;
